import { Button, CircularProgress, Dialog, Modal, Divider } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
import ProceduresManualContext from './ProceduresManualContext';
import ProceduresManualHeader from './ProceduresManualHeader';
import ProceduresManualTable from './ProceduresManualTable';
import ProceduresManualFooter from './ProceduresManualFooter';
import _ from 'lodash';

const Container = styled.div`

    justify-content:space-around;
    flex-direction:column;
    display:grid;
    grid-template-rows : ${props => props.gridTemplateRows};
    grid-template-columns : 1fr;
    background-color:white;
    margin:20px;
    border-radius:10px;
    overflow:hidden;
    ${props => props.height ? `height: ${props.height} ` : ''};
`;

const OuterContainer = styled.div`
    height: ${props => props.height + 'px'};
    display:flex;
    align-items:center;
    justify-content:center;
    border-radius:10px;
    overflow:hidden;
`

const PaperContainer = styled.div`

    display:flex;


`;


const ProcedureManualTableContainer = styled.div`
    width:100%;
    overflow-y:auto;
`;

const ModalContainer = styled.div`

`



class ProceduresManualModal extends React.Component {

    static contextType = ProceduresManualContext;

    constructor(props) {
        super(props);
        this.state = { projectToAdd: null };
    }

    render() {
        return <ProceduresManualContext.Consumer>{context => this.renderContent(context)}</ProceduresManualContext.Consumer>

    }


    renderContent(context) {

        const loading = !context.procedureManual.header;
        const { creatingProcedureManual, actionGroupForDisplayedProcedureManual, procedureManualShouldUpdate, header, procedures } = context.procedureManual;
        const { sortProperty, sortReverse } = context;

        let sortedProcedures = _.orderBy(procedures, procedure => (typeof procedure[sortProperty] === 'string') ? procedure[sortProperty].toUpperCase() : procedure[sortProperty]);
        sortedProcedures = sortReverse ? sortedProcedures : _.reverse(sortedProcedures);

        return (
            <Modal open={true} >
                <OuterContainer height={window.innerHeight}>
                    {/* gridTemplateRows={`258px minmax(auto,${window.innerHeight - 40 - 258 - 68}px) 68px`} */}
                    <Container height={'94%'}>

                        {!loading &&
                            <React.Fragment>
                                <ProceduresManualHeader />
                                <ProcedureManualTableContainer>
                                    {creatingProcedureManual ? <CircularProgress /> : <ProceduresManualTable procedures={sortedProcedures} />}
                                </ProcedureManualTableContainer>
                                <ProceduresManualFooter />
                            </React.Fragment>
                        }
                    </Container>
                </OuterContainer>
            </Modal>


        )
    }
}

export default ProceduresManualModal;